import { createContext } from "react";
export const PortfolioDataContext = createContext(null);